<template>
    <div style="margin-top: -70px" >
        <el-carousel class="head_tu "  :interval="300000" arrow="never" :height="dataHeight" :autoplay="true" >
            <el-carousel-item v-for="(item,idexy) in dataimg" :key="idexy">
                <img :src="item.src"/>
                <div class="index_banner_butn" v-if="item.txt">
                    <p @click="$router.push({name: 'productDownload'})">{{item.txt}}</p>
                </div>
                <div class="index_content" v-if="item.txt1">
                    <div class="index_content_btn ">
                        <!-- <a href="view/register.html" class="index_free_re">免费注册</a> -->
                        <p class="index_download" @click="$router.push({name: 'productDownload'})">立即下载</p>
                    </div>
                </div>
            </el-carousel-item>
        </el-carousel>
        <div class="sign_experience"  >
            <p class="sign_line"></p>
            <h1 class="sign_title ">感受大众签章的卓越体验</h1>
            <p class="sign_intro sign_intro_diff0 ">打通数字化办公“最后一公里”</p>
            <div class="experience sign_feature clearfix " >
                <div class="text">
                    <div class="m_top">
                        <img src="@/assets/img/user/icon_connection.png" alt="">
                        <div class="sign_feature_text">
                            <p class="title">多端互联</p>
                            <p class="intro">移动客户端、PC客户端、Web网页全平台覆盖；
                                适配多种终端设备，随时随地调用签章服务</p>
                        </div>
                    </div>
                    <div>
                        <img src="@/assets/img/user/icon_light.png" alt="">
                        <div class="sign_feature_text">
                            <p class="title">便捷高效</p>
                            <p class="intro">界面简洁，操作方便，极速签约；
                                轻量级应用，安装简单，稳定运行</p>
                        </div>
                    </div>
                    <div class="m_top">
                        <img src="@/assets/img/user/icon_quickly.png" alt="">
                        <div class="sign_feature_text">
                            <p class="title">安全可靠</p>
                            <p class="intro">数字证书由权威CA机构颁发；
                                短信身份验证，确保签章操作安全；
                                数字签名等技术确保信息真实且不可篡改</p>
                        </div>
                    </div>
                    <div>
                        <img src="@/assets/img/user/icon_safety.png" alt="">
                        <div class="sign_feature_text">
                            <p class="title">合法有据</p>
                            <p class="intro">符合国家《电子签名法》各项规定，法律效力完备；
                                提供完整的合同证据链，保障用户合法权益</p>
                        </div>
                    </div>

                </div>
                <div class="line">
                    <div class="">
                        <img src="@/assets/img/user/line_connector-up.png" alt="">
                    </div>
                    <div class="m_top_l">
                        <img src="@/assets/img/user/line_connector-down.png" alt="">
                    </div>
                    <div class="">
                        <img src="@/assets/img/user/line_connector-up.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="one_question clearfix ">
            <!--三块分类-->
            <div class="question_three clearfix ">
                <div class="question_three_inner clearfix ">
                    <a href="javascript:void(0);" class="question_three_block clearfix"
                       @click="$router.push({name: 'productCente'})">
                        <span class="icon_image"><img src="@/assets/img/user/icon_seal.png" alt=""></span>
                        <div class="icon_text">
                            <p>还不知道大众签章？</p>
                            <p>产品介绍</p>
                        </div>
                    </a>
                    <a href="javascript:void(0);" class="question_three_block clearfix"
                       @click="$router.push({path: '/news/newsHy/6'})">
                        <span class="icon_image"><img src="@/assets/img/user/icon_what.png" alt=""></span>
                        <div class="icon_text">
                            <p>什么是电子印章？</p>
                            <p>印章百科</p>
                        </div>
                    </a>
                    <a href="javascript:void(0);" class="question_three_block clearfix"
                       @click="$router.push({name: 'lawProtect'})">
                        <span class="icon_image"><img src="@/assets/img/user/icon_law.png" alt=""></span>
                        <div class="icon_text">
                            <p>怕违约？没关系，看这边！</p>
                            <p>法律服务</p>
                        </div>
                    </a>
                </div>
            </div>
            <p class="sign_line"></p>
            <h2 class="sign_title ">享有大众签章的全链条服务</h2>
            <p class="sign_intro sign_intro_diff ">一站式解决所有签约难题</p>
            <div class="sign_module clearfix ">
                <div class="sign_module_block sign_module_block_diff clearfix">
                    <span><img src="@/assets/img/user/icon_sign.png" alt=""></span>
                    <div class="sign_module_block_text">
                        <h5>文件签署</h5>
                        <p>提供电子合同的创建、发送、签署和归档在内的一站式服务，使签约不再受时间和地域的限制，有网就能签，提高合同的签署效率。</p>
                    </div>
                </div>
                <div class="sign_module_block clearfix">
                    <span><img src="@/assets/img/user/icon_law2.png" alt=""></span>
                    <div class="sign_module_block_text">
                        <h5>合同管理</h5>
                        <p>合同电子化存储，方便日常管理，最大化解放人力物力，为企业降低运营成本，同时提供海量合同模版下载，满足多种签约场景。</p>
                    </div>
                </div>
                <div class="sign_module_block sign_module_block_diff clearfix">
                    <span><img src="@/assets/img/user/icon_contacts.png" alt=""></span>
                    <div class="sign_module_block_text">
                        <h5>法律支持</h5>
                        <p>与司法鉴定机构、公证处、人民法院等法律机构合作，提供保全公证、司法鉴定、在线仲裁等多种法律增值服务，打通电子签名全链条。</p>
                    </div>
                </div>
                <div class="sign_module_block clearfix">
                    <span><img src="@/assets/img/user/icon_law1.png" alt=""></span>
                    <div class="sign_module_block_text">
                        <h5>账户权限管理</h5>
                        <p>提供个人用户及企业用户两种注册方式，企业内部账户权限合理划分，防止权限不清，职责不明，确保企业用章有序。</p>
                    </div>
                </div>
                <div class="mob_sign_module_block clearfix">
                    <p class="mob_sign_title">
                        <img src="@/assets/img/user/icon_sign_cut.png" alt="">
                        <span>文件签署</span>
                    </p>
                    <p class="mob_sign_para">
                        提供电子合同的创建、发送、签署和归档在内的一站式服务，使签约不再受时间和地域的限制，有网就能签，提高合同的签署效率。
                    </p>
                </div>
                <div class="mob_sign_module_block clearfix">
                    <p class="mob_sign_title">
                        <img src="@/assets/img/user/icon_law2_cut.png" alt="">
                        <span>合同管理</span>
                    </p>
                    <p class="mob_sign_para">
                        合同电子化存储，方便日常管理，最大化解放人力物力，为企业降低运营成本，同时提供海量合同模版下载，满足多种签约场景。
                    </p>
                </div>
                <div class="mob_sign_module_block clearfix">
                    <p class="mob_sign_title">
                        <img src="@/assets/img/user/icon_contacts_cut.png" alt="">
                        <span>法律支持</span>
                    </p>
                    <p class="mob_sign_para">
                        与司法鉴定机构、公证处、人民法院等法律机构合作，提供保全公证、司法鉴定、在线仲裁等多种法律增值服务，打通电子签名全链条。
                    </p>
                </div>
                <div class="mob_sign_module_block clearfix">
                    <p class="mob_sign_title">
                        <img src="@/assets/img/user/icon_law1_cut.png" alt="">
                        <span>用户权限管理</span>
                    </p>
                    <p class="mob_sign_para">
                        提供个人用户及企业用户两种注册方式，企业内部账户权限合理划分，防止权限不清，职责不明，确保企业用章有序。
                    </p>
                </div>
            </div>
        </div>
        <div class="video_box "  >
            <div class="btm_video_box"></div>
            <div class="video_box_text">
                <img class="click_play " src="@/assets/img/icon_broadcast.png" alt=""
                     @click="add_signature_dialog=true">
                <p class="video_intro_top ">观看大众签章宣传视频</p>
                <p class="video_intro_btm ">给您带来互联网时代签约的全新体验</p>
            </div>
            <div class="video_pause">
                <img src="@/assets/img/icon_broadcast_pause.png" alt="">
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" v-dialogDrag title="签章宣传视频" :visible.sync="add_signature_dialog"
                   width="50%" center>
            <video-player id="index_video" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
                          :options="playerOptions"></video-player>
        </el-dialog>
        <div class="app_use clearfix">
            <p class="sign_line"></p>
            <h2 class="sign_title ">获取大众签章的多场景支持</h2>
            <p class="sign_intro sign_intro_diff2 ">全线助力各行业互联网+进程</p>
            <!--轮播-->
            <div class="app_scroll  v-1220">
                <div class="bd">
                    <el-carousel :interval="5000" arrow="always" height="420px" indicator-position="none" class="my-swipe">
                        <el-carousel-item >
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a>-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionGovern'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img1.png" alt="">
                                    <div class="text">
                                        <p>电子政务</p>
                                        <p>保障涉密信息安全，助力政府机构无纸化办公，提高公共服务效率</p>
                                    </div>
                                    <!--</a>-->
                                </div>

                            </div>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a href="">-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionAffair'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img4.png" alt="">
                                    <div class="text">
                                        <p>电子商务</p>
                                        <p>缩短企业入驻及交易周期，帮助平台及企业双方规避交易风险</p>
                                    </div>
                                    <!--</a>-->
                                </div>
                            </div>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a href="">-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionSecure'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img3.png" alt="">
                                    <div class="text">
                                        <p>保险信贷</p>
                                        <p>固化电子合同权责，确保签约双方不可抵赖，保障信贷安全</p>
                                    </div>
                                    <!--</a>-->
                                </div>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item >
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a href="">-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionTour'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img2.png" alt="">
                                    <div class="text">
                                        <p>旅游行业</p>
                                        <p>简化旅社与客户签约流程，异地签约可行，提升旅社签单效率</p>
                                    </div>
                                    <!--</a>-->
                                </div>
                            </div>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a href="">-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionRent'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img5.png" alt="">
                                    <div class="text">
                                        <p>房屋租赁</p>
                                        <p>确保甲乙双方真实身份，消除阴阳合同，降低房屋租赁成本</p>
                                    </div>
                                    <!--</a>-->
                                </div>
                            </div>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a>-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionGovern'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img1.png" alt="">
                                    <div class="text">
                                        <p>电子政务</p>
                                        <p>保障涉密信息安全，助力政府机构无纸化办公，提高公共服务效率</p>
                                    </div>
                                    <!--</a>-->
                                </div>

                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="app_scroll  v-368">
                <div class="bd">
                    <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white" :show-indicators="false">
                        <van-swipe-item>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a>-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionGovern'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img1.png" alt="">
                                    <div class="text">
                                        <p>电子政务</p>
                                        <p>保障涉密信息安全，助力政府机构无纸化办公，提高公共服务效率</p>
                                    </div>
                                    <!--</a>-->
                                </div>

                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a href="">-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionAffair'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img4.png" alt="">
                                    <div class="text">
                                        <p>电子商务</p>
                                        <p>缩短企业入驻及交易周期，帮助平台及企业双方规避交易风险</p>
                                    </div>
                                    <!--</a>-->
                                </div>
                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a href="">-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionSecure'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img3.png" alt="">
                                    <div class="text">
                                        <p>保险信贷</p>
                                        <p>固化电子合同权责，确保签约双方不可抵赖，保障信贷安全</p>
                                    </div>
                                    <!--</a>-->
                                </div>
                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a href="">-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionTour'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img2.png" alt="">
                                    <div class="text">
                                        <p>旅游行业</p>
                                        <p>简化旅社与客户签约流程，异地签约可行，提升旅社签单效率</p>
                                    </div>
                                    <!--</a>-->
                                </div>
                            </div>
                        </van-swipe-item>
                        <van-swipe-item>
                            <div class="app_scroll_block">
                                <div class="app_scroll_block_sub">
                                    <!--<a href="">-->
                                    <div class="blank_bg"></div>
                                    <a class="app_scroll_block_sub_look" href="javascript:void(0);"
                                       @click="$router.push({name: 'indusSolutionRent'})">了解详情</a>
                                    <img src="@/assets/img/user/index_sence_img5.png" alt="">
                                    <div class="text">
                                        <p>房屋租赁</p>
                                        <p>确保甲乙双方真实身份，消除阴阳合同，降低房屋租赁成本</p>
                                    </div>
                                    <!--</a>-->
                                </div>
                            </div>
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import scrollReveal from 'scrollreveal';
    import AOS from "aos";
    AOS.init();
    export default {
        name: "home_page",
        data() {
            return {

                scrollReveal: scrollReveal(),
                dataHeight: document.body.clientHeight + 60 + 'px',
                dataimg: [{
                    src: require('@/assets/img/banner/index-banner.png'),
                    txt: '客户端下载',
                },
                    {
                        src: require('@/assets/img/banner/index_banner1.png'),
                        txt1: '大众一体化电子合同平台',
                        txt2: '互联网签章开启新篇章',
                        txt3: '客户端下载'
                    },
                    {
                        src: require('@/assets/img/banner/index_banner2.png'),
                    }
                ],
                add_signature_dialog: false,
                playerOptions: {
                    playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
                    autoplay: true, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN', aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        type: "",
                        src: 'https://aiosign.com/filePath1/group1/M00/00/03/rBABhF7afwCAO0LhAGPEpm70OWY288.mp4'//url地址
                    }],
                    poster: "", //你的封面地址
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,//当前时间和持续时间的分隔符
                        durationDisplay: true,//显示持续时间
                        remainingTimeDisplay: false,//是否显示剩余时间功能
                        fullscreenToggle: true  //全屏按钮
                    }
                },
                screenWidth: document.body.clientWidth,
                // screenHeight: document.body.clientHeight,
            }
        },

        mounted() {
            this.scrollReveal.reveal('.reveal-top', {
                duration: 2000,
                delay: 0,
                origin: 'left',
                reset: true,
                mobile: true,
                opacity: 0.001,
                easing: 'linear',
                scale: 0.9,
            });
            this.aos.init({
                offset: 200,
                duration: 600,
                easing: 'ease-in-sine',
                delay: 100
            });
            this.$nextTick(() => {

            })
        },
        methods: {
            getHeight() {
                // if( window.innerWidth > 1320){
                this.width = window.innerWidth;
                this.height = window.innerHeight;
                this.dataHeight = this.width / 2.13 + 'px'
                // }else {
                //     this.dataHeight = 1320/2.13 +'px'
                // }
            }
        },
        created() {
            window.addEventListener('resize', this.getHeight);
            this.getHeight()
        },
        destroyed() {
            window.removeEventListener('resize', this.getHeight)
        }
    }
</script>

<style scoped>
    .head_tu {
        width: 100%;
        cursor: pointer;
        overflow: hidden;
    }
    .v-1220{
        width: 1300px;
    }
    .app_scroll .bd{
        width: 1300px;
    }
    .my-swipe .el-carousel__item{
        padding-left: 50px;
    }


    @media screen and (max-width: 1024px) and (min-width: 320px) {
        /*.head_tu {*/
        /*    height: 200px !important;*/
        /*}*/
        /*.head_tu >>> .el-carousel__container {*/
        /*    height: 100% !important;*/
        /*}*/
    }
    .head_tu img {
        width: 100%;
       height: auto;
    }
</style>